<template>
  <div data-testid="full-screen-loader" class="tw:fixed tw:h-full tw:bg-white tw:opacity-80 tw:z-50 tw:inset-0">
    <LaunchpadLoader class="tw:h-screen tw:flex tw:items-center tw:justify-center" />
  </div>
</template>
<script setup>
import LaunchpadLoader from '@/components/dashboard/common/LaunchpadLoader.vue'
</script>
